export const defaultPremiumState = {
    isProfessionalPremium: false,
    isSmartPremium: false,
    userInTrialMode: false,
    trialEndTime: 0,
    showProfessionalPremiumSettings: false,
    showSmartPremiumSettings: false,
    isDeveloper: false,
    iconModalOn: false
}

// дефолтное состояние при редактировании виджета (слайдов, капч, параллакса)
export const defaultSlideState = {
    // actionIndex: -1,
    // actions: [],
    captions: [],
    backgroundColor: 'rgba(234, 247, 255, 1)',
    backgroundType: 'color',
    backgroundGradient: [{
        angle: 45,
        firstColor: "rgba(251, 247, 173, 1)",
        secondColor: "rgba(80, 196, 237, 1)",
        transition: 100,
    }],
    // backgroundColor: {
    //     type: 'color',
    //     colorValue: 'rgba(234, 247, 255, 1)',
    // gradientLayers: [{
    //     angle: 45,
    //     firstColor: "rgba(251, 247, 173, 1)",
    //     secondColor: "rgba(80, 196, 237, 1)",
    //     transition: 100,
    // }]
    // },
    slideName: 'Slide',
    hasBackgroundShadow: false,
    // needMobileConvert: true,
    backgroundShadow: {
        angle: 0,
        distance: 0,
        x: 0,
        y: 0,
        blur: 20,
        size: 10,
        color: 'rgba(0,0,0,0.3) inset',
    },
    isHide: false,
    editedHeight: 330,
    editedWidth: 970,
    editedHeightMobile: 105,
    editedWidthMobile: 280,
    // widgetData: {
    //     originalWidth: 0,
    //     originalHeight: 0,  
    //     width: 0,
    //     height: 0,
    //     mobileWidth: 0,
    //     mobileHeight: 0,
    // }
};

export const defaultCaptionState = {
    animationIn: 'fadeIn',
    animationModeIn: 'sequence',
    animationModeOut: 'sequence',
    animationOut: 'fadeOut',
    backgroundColor: 'rgba(255,255,255,0)',
    backgroundColorHover: 'rgba(155,155,155,0.5)',
    borderColor: 'rgba(255,255,255,0.5)',
    borderColorHover: 'rgba(155,155,155,0.5)',
    borderWidth: 0,
    borderRadius: 0,
    boxId: '',
    delayIn: 0,
    delayOut: 0,
    // delayOut: 2600,
    fontColor: 'rgba(33, 33, 33, 1)',
    fontColorHover: 'rgba(33, 33, 33, 0.5)',
    fontFamily: {
        label: 'Sans-serif',
        value: 'sans-serif'
    },
    fontSize: 40,
    // fontSize: 40,
    hasShadow: false,
    id: '',
    index: 0,
    lineColors: [],
    letterCase: 'none',
    letterSpacing: 0,
    lineHeight: 100,
    // mobileBorderWidth: 0,
    // mobileBorderRadius: 0,
    // mobileFontSize: 10,
    // mobileLetterSpacing: 0,
    // mobileLineHeight: 100,
    // mobilePadding: 0,
    mobileShow: true,
    // mobileHeight: 11,
    // mobileWidth: 36,
    needMobileConvert: true,
    isHover: false,
    layer: 1,
    onClick: {
        label: "Do nothing",
        value: "doNothing"
    },
    linkTo: null,
    // linkType: {
    //     label: 'Wix',
    //     value: 'wix'
    // },
    // link: 'https://ru.wix.com/',
    // mobilePosition: {
    //     relativeX: 10,
    //     relativeY: 10,
    //     x: 10,
    //     y: 10,
    // },
    padding: 0,
    position: {
        relativeX: 30,
        relativeY: 30,
        x: 30,
        y: 30,
    },

    selectedLine: 0,
    shadow: {
        angle: 135,
        distance: 4,
        x: 3,
        y: 3,
        blur: 5,
        size: 1,
        color: 'rgba(0,0,0,0.5)',
    },
    style: {
        bold: false,
        italic: false,
        underline: false,
        textAlign: 'left',
    },
    text: 'Caption',
    type: 'text',
    width: 143,
    height: 45,
    version: 2,
}

export const defaultButtonCaption = {
    animation: { value: 'sweep-to-right', class: 'background', label: 'Sweep to right' },
    animationIn: 'bounceIn',
    animationOut: 'bounceOut',
    // animationDelay: "0",
    // animationDuration: "600",
    // backgroundColor: 'rgba(235,197,248,1)',
    backgroundColor: 'rgba(0, 0, 0, 1)',
    backgroundColorHover: 'rgba(255, 255, 255, 1)',
    borderRadius: 8,
    // borderRadius: 0,
    // mobileBorderRadius: 0,
    borderColor: 'rgba(0,0,0,1)',
    borderColorHover: 'rgba(0,0,0,1)',
    borderWidth: 1,
    // mobileBorderWidth: 0,
    delayIn: 0,
    delayOut: 0,
    // delayIn: 1000,
    // delayOut: 1000,
    id: '',
    isHover: false,
    hasShadow: false,
    textHasShadow: false,
    boxId: '',
    index: 0,
    layer: 1,
    // fontColor: 'rgba(43,86,114,1)',
    fontColor: 'rgba(255,255,255,1)',
    fontColorHover: 'rgba(0, 0, 0, 1)',
    fontFamily: { value: "'Montserrat', sans-serif, Medium", label: "Montserrat Medium", fontWeight: 500 },
    fontShadow: false,
    fontSize: 24,
    // fontSize: 25,
    letterCase: 'none',
    letterSpacing: 0,
    lineHeight: 100,
    // mobileFontSize: 10,
    mobileShow: true,
    // mobileLetterSpacing: 0,
    // mobileLineHeight: 100,
    needMobileConvert: true,
    onClick: {
        label: "Do nothing",
        value: "doNothing"
    },
    linkTo: null,
    // нужны ли linkType и link?
    // linkType: {
    //     label: 'Wix',
    //     value: 'wix'
    // },
    // link: 'https://ru.wix.com/',

    padding: 13,
    // padding: 10,
    // mobilePadding: 2,
    position: {
        relativeX: 30,
        relativeY: 30,
        x: 50,
        y: 50,
    },
    // mobilePosition: {
    //     relativeX: 10,
    //     relativeY: 10,
    //     x: 10,
    //     y: 10,
    // },
    shadow: {
        angle: 135,
        distance: 4,
        x: 3,
        y: 3,
        blur: 5,
        size: 1,
        color: 'rgba(0,0,0,0.5)',
    },
    textShadow: {
        angle: 135,
        distance: 4,
        x: 3,
        y: 3,
        blur: 5,
        size: 1,
        color: 'rgba(0,0,0,0.5)',
    },
    style: {
        bold: false,
        italic: false,
        underline: false,
        textAlign: 'center',
    },
    text: 'BUTTON TEXT',
    type: 'button',
    width: 235,
    // width: 200,
    // width: 140,
    height: 52,
    version: 2,
    // height: 49,
    // mobileWidth: 52,
    // mobileHeight: 16,
}

export const defaultBoxCaption = {
    animationIn: 'bounceIn',
    animationOut: 'bounceOut',
    // pointsArray: [
    //     { x: 0, y: 0 },
    //     { curvePoints: [{ x: 20, y: 0 }, { x: 330, y: 0 }], x: 350, y: 0 },
    //     { curvePoints: [{ x: 350, y: 20 }, { x: 350, y: 180 }], x: 350, y: 200 },
    //     { curvePoints: [{ x: 330, y: 200 }, { x: 20, y: 200 }], x: 0, y: 200 }
    // ],
    // backgroundColor: 'rgba(80, 196, 237, 1)',
    backgroundColor: {
        type: 'color',
        colorValue: "rgba(171, 175, 247, 1)",
        // colorValue: 'rgba(80, 196, 237, 1)',
        // colorValue: 'rgba(235,197,248,1)',
        gradientLayers: [{
            // angle: 180,
            angle: 47,
            firstColor: "rgba(234, 214, 238, 1)",
            secondColor: "rgba(160, 241, 234, 1)",
            // firstColor: "rgba(235,197,248,1)",
            // secondColor: "rgba(186,23,241,1)",
            // firstColor: "rgba(58, 84, 180, 1)",
            // secondColor: "rgba(42, 138, 157, 1)",
            transition: 100,
            // transition: 64,
        }]
    },
    borderColor: 'rgba(240, 240, 240, 1)',
    borderRadius: {
        leftTop: 0,
        rightTop: 0,
        leftBottom: 0,
        rightBottom: 0
    },
    borderWidth: 0,
    delayIn: 0,
    delayOut: 0,
    hasShadow: false,
    // height: 170,
    height: 140,
    mobileShow: true,
    needMobileConvert: true,
    id: '',
    boxId: '',
    index: 0,
    layer: 1,
    position: {
        relativeX: 50,
        relativeY: 50,
        x: 50,
        y: 50,
    },
    separateCorners: false,
    shadow: {
        angle: 135,
        distance: 4,
        x: 3,
        y: 3,
        blur: 5,
        size: 1,
        color: 'rgba(0,0,0,0.5)',
    },
    type: 'box',
    // width: 260,
    width: 140,
    version: 2,
}


export const defaultShapeCaption = {
    animationIn: 'bounceIn',
    animationOut: 'bounceOut',
    backgroundColor: {
        type: 'gradient',
        // colorValue: 'rgba(235,197,248,1)',
        colorValue: 'rgba(80, 196, 237, 1)',
        gradientLayers: [{
            // angle: 180,
            // firstColor: "rgba(235,197,248,1)",
            // secondColor: "rgba(186,23,241,1)",
            angle: 45,
            firstColor: "rgba(251, 247, 173, 1)",
            secondColor: "rgba(80, 196, 237, 1)",
            transition: 100,
        }]
    },
    boxId: '',
    borderColor: 'rgba(240, 240, 240, 1)',
    borderRadius: {
        leftTop: 0,
        rightTop: 0,
        leftBottom: 0,
        rightBottom: 0
    },
    borderWidth: 0,
    delayIn: 0,
    delayOut: 0,
    id: '',
    index: 0,
    hasShadow: false,
    // height: 150,
    height: 140,
    layer: 1,

    mobileShow: true,
    needMobileConvert: true,
    position: {
        relativeX: 50,
        relativeY: 50,
        x: 50,
        y: 50,
    },
    separateCorners: false,
    separateCornersMobile: false,
    shadow: {
        angle: 135,
        distance: 4,
        x: 3,
        y: 3,
        blur: 5,
        size: 1,
        color: 'rgba(0,0,0,0.5)',
    },
    type: 'shape',
    // width: 200,
    width: 140,
    version: 2,
}

export const defaultImageCaption = {
    animationIn: 'bounceIn',
    animationOut: 'bounceOut',
    padding: 0,
    backgroundColor: {
        type: 'color',
        // colorValue: 'rgba(235,197,248,1)',
        colorValue: 'rgba(80, 196, 237, 0)',
        gradientLayers: [{
            // angle: 180,
            // firstColor: "rgba(235,197,248,1)",
            // secondColor: "rgba(186,23,241,1)",
            angle: 45,
            firstColor: "rgba(251, 247, 173, 1)",
            secondColor: "rgba(80, 196, 237, 1)",
            transition: 100,
        }]
    },
    overlayColor: {
        type: 'color',
        // colorValue: 'rgba(235,197,248,1)',
        colorValue: 'rgba(80, 196, 237, 0)',
        gradientLayers: [{
            // angle: 180,
            // firstColor: "rgba(235,197,248,1)",
            // secondColor: "rgba(186,23,241,1)",
            angle: 45,
            firstColor: "rgba(251, 247, 173, .4)",
            secondColor: "rgba(80, 196, 237, .45)",
            transition: 100,
        }]
    },
    flip: {
        x: false,
        y: false
    },
    crop: {
        scale: 100,
        centerPoint: { x: .5, y: .5 },
    },
    boxId: '',
    borderColor: 'rgba(240, 240, 240, 1)',
    borderRadius: 0,
    borderWidth: 0,
    delayIn: 0,
    delayOut: 0,
    id: '',
    onClick: {
        label: "Do nothing",
        value: "doNothing"
    },
    linkTo: null,
    index: 0,
    hasShadow: false,
    // height: 150,
    height: 140,
    layer: 1,
    mobileShow: true,
    needMobileConvert: true,
    position: {
        relativeX: 50,
        relativeY: 50,
        x: 50,
        y: 50,
    },
    shadow: {
        angle: 135,
        distance: 4,
        x: 3,
        y: 3,
        blur: 5,
        size: 1,
        color: 'rgba(0,0,0,0.5)',
    },
    type: 'image',
    // width: 200,
    width: 140,
    version: 2,
}

// export const defaultSlides = [{"backgroundShadow":{"angle":0,"distance":0,"x":0,"y":0,"blur":20,"size":10,"color":"rgba(0,0,0,0.3) inset"},"captions":[{"mobilePosition":{"relativeX":10,"relativeY":10,"x":72,"y":13},"position":{"relativeX":50,"relativeY":50,"x":303.50694274902344,"y":38},"shadow":{"angle":40,"distance":0,"x":0,"y":0,"blur":20,"size":8,"color":"rgba(0,0,0,0.5)"},"lineColors":[],"textArray":[],"_id":"610950bad386e2342a7f6bfe","animationIn":"fadeIn","animationOut":"fadeOut","backgroundColor":{"type":"color","colorValue":"rgba(28, 28, 28, 0)","gradientLayers":[{"angle":47,"firstColor":"rgba(234, 214, 238, 1)","secondColor":"rgba(160, 241, 234, 1)","transition":100}]},"borderColor":"rgba(252, 252, 252, 1)","borderRadius":{"leftTop":0,"rightTop":0,"leftBottom":0,"rightBottom":0},"mobileBorderRadius":{"leftBottom":0,"leftTop":0,"rightBottom":0,"rightTop":0},"borderWidth":0,"mobileBorderWidth":0,"delayIn":0,"delayOut":0,"hasShadow":true,"height":277.98614501953125,"mobileHeight":80,"mobileShow":true,"mobileWidth":136.99654027035362,"id":"id-1627987644436","boxId":"","index":0,"layer":1,"separateCorners":false,"type":"box","width":362.9861145019531,"separateCornersMobile":false},{"mobilePosition":{"relativeX":0,"relativeY":54,"x":65,"y":26},"position":{"x":350,"y":221,"relativeX":44.51390075683594,"relativeY":182},"style":{"bold":false,"italic":false,"underline":false,"textAlign":"center"},"shadow":{"angle":135,"distance":3,"x":2,"y":2,"blur":5,"size":1,"color":"rgba(0, 0, 0, 1)"},"lineColors":["rgba(255, 255, 255, 1)","rgba(255, 255, 255, 1)","rgba(255, 255, 255, 1)"],"textArray":["Emotions","FEELING","PHOTOS"],"_id":"60d59891f86638684d1ece75","animationIn":"none","animationOut":"fadeOutLeft","animationModeIn":"shuffle","animationModeOut":"sequence","backgroundColor":"rgba(41, 8, 88, 0)","backgroundColorHover":"rgba(155,155,155,0.5)","borderWidth":0,"boxId":"id-1627987644436","borderRadius":0,"borderColor":"rgba(255,255,255,0.5)","borderColorHover":"rgba(255,255,255,0.5)","delayIn":0,"delayOut":0,"id":"id-1613812434068","index":1,"hasShadow":false,"fontColor":"rgba(255, 255, 255, 1)","fontColorHover":"rgba(33, 33, 33, 0.5)","fontFamily":{"value":"helvetica-w01-light,helvetica-w02-light,sans-serif","label":"Helvetica Light"},"fontSize":16,"letterCase":"uppercase","letterSpacing":84,"lineHeight":149,"mobileBorderWidth":0,"mobileBorderRadius":0,"mobileFontSize":14,"mobileLetterSpacing":14,"mobileLineHeight":120,"mobileShow":true,"isHover":false,"layer":1,"padding":0,"mobilePadding":0,"text":"COSMETICS","type":"text","width":273.9583740234375,"height":22.22222328186035,"mobileWidth":130.00003212376646,"mobileHeight":16,"pauseBetweenLines":1000,"lang":{"en":{"text":"COSMETICS","fontFamily":{"value":"helvetica-w01-light,helvetica-w02-light,sans-serif","label":"Helvetica Light"},"isRTL":false,"textArray":["Emotions","FEELING","PHOTOS"]}}},{"mobilePosition":{"relativeX":9,"relativeY":6,"x":47,"y":60},"position":{"x":306,"y":155,"relativeX":44.51390075683594,"relativeY":78},"style":{"bold":false,"italic":false,"underline":false,"textAlign":"center"},"shadow":{"angle":135,"distance":3,"x":2,"y":2,"blur":0,"size":1,"color":"rgba(13, 33, 48, 1)"},"lineColors":[],"textArray":[],"_id":"60d59891f86638684d1ece75","animationIn":"fadeInLeft","animationOut":"fadeOut","animationModeIn":"sequence","animationModeOut":"shuffle","backgroundColor":"rgba(41, 8, 88, 0)","backgroundColorHover":"rgba(155,155,155,0.5)","borderWidth":0,"boxId":"id-1627987644436","borderRadius":0,"borderColor":"rgba(255,255,255,0.5)","borderColorHover":"rgba(255,255,255,0.5)","delayIn":0,"delayOut":0,"id":"id-1624863613465","index":2,"hasShadow":true,"fontColor":"rgba(255, 255, 255, 1)","fontColorHover":"rgba(33, 33, 33, 0.5)","fontFamily":{"value":"cormorantgaramond-light,cormorantgaramond,\\"cormorant garamond\\",serif","label":"Cormorant Garamond Light"},"fontSize":82,"letterCase":"uppercase","letterSpacing":25,"lineHeight":113,"mobileBorderWidth":0,"mobileBorderRadius":0,"mobileFontSize":43,"mobileLetterSpacing":14,"mobileLineHeight":120,"mobileShow":true,"isHover":false,"layer":1,"padding":0,"mobilePadding":0,"text":"eco","type":"text","width":273.9756774902344,"height":91.11111450195312,"mobileWidth":120.98956459446958,"mobileHeight":50,"needMobileConvertOnlyPosition":true,"mobileHidden":false,"lang":{"en":{"text":"eco","fontFamily":{"value":"cormorantgaramond-light,cormorantgaramond,\\"cormorant garamond\\",serif","label":"Cormorant Garamond Light"},"isRTL":false,"textArray":[]}}}],"_id":"60d59891f86638684d1ece74","backgroundColor":"rgba(28, 28, 28, 0.24)","backgroundType":"color","backgroundGradient":[{"angle":90,"firstColor":"rgba(13, 33, 48, 0.5)","secondColor":"rgba(119, 114, 71, 0)","transition":32},{"angle":270,"firstColor":"rgba(160, 200, 254, 0.2)","secondColor":"rgba(251, 247, 173, 0)","transition":11}],"slideName":"COSMETICS 1","hasBackgroundShadow":false,"editedHeight":365,"editedWidth":970,"editedHeightMobile":105,"editedWidthMobile":280,"id":"585705103524561","index":0,"isHide":false},{"backgroundShadow":{"angle":0,"distance":0,"x":0,"y":0,"blur":20,"size":10,"color":"rgba(0,0,0,0.3) inset"},"captions":[{"mobilePosition":{"relativeX":0,"relativeY":6,"x":65,"y":26},"position":{"x":654,"y":175,"relativeX":18,"relativeY":14},"style":{"bold":false,"italic":false,"underline":false,"textAlign":"center"},"shadow":{"angle":135,"distance":3,"x":2,"y":2,"blur":5,"size":1,"color":"rgba(0, 0, 0, 1)"},"lineColors":["rgba(255, 255, 255, 1)","rgba(255, 255, 255, 1)","rgba(255, 255, 255, 1)"],"textArray":["fresh","novel","original"],"_id":"60d59891f86638684d1ece75","animationIn":"countdownUp","animationOut":"fadeOutLeft","animationModeIn":"shuffle","animationModeOut":"sequence","backgroundColor":"rgba(41, 8, 88, 0)","backgroundColorHover":"rgba(155, 155, 155, 0)","borderWidth":0,"boxId":"id-1627992794512","borderRadius":0,"borderColor":"rgba(255,255,255,0.5)","borderColorHover":"rgba(255, 255, 255, 0)","delayIn":0,"delayOut":0,"id":"id-1613812434068","index":0,"hasShadow":false,"fontColor":"rgba(255, 255, 255, 1)","fontColorHover":"rgba(255, 255, 255, 1)","fontFamily":{"value":"helvetica-w01-light,helvetica-w02-light,sans-serif","label":"Helvetica Light"},"fontSize":35,"letterCase":"uppercase","letterSpacing":18,"lineHeight":149,"mobileBorderWidth":0,"mobileBorderRadius":0,"mobileFontSize":14,"mobileLetterSpacing":14,"mobileLineHeight":120,"mobileShow":true,"isHover":true,"layer":1,"padding":0,"mobilePadding":0,"text":["fresh","novel","original"],"type":"text","width":256.9965515136719,"height":51.111114501953125,"mobileWidth":130,"mobileHeight":16,"pauseBetweenLines":1000,"lang":{"en":{"text":["fresh","novel","original"],"fontFamily":{"value":"helvetica-w01-light,helvetica-w02-light,sans-serif","label":"Helvetica Light"},"isRTL":false,"textArray":["fresh","novel","original"]}}},{"mobilePosition":{"relativeX":10,"relativeY":10,"x":10,"y":13},"position":{"x":69,"y":91,"relativeX":13,"relativeY":96},"style":{"bold":false,"italic":false,"underline":false,"textAlign":"left"},"shadow":{"angle":135,"distance":3,"x":2,"y":2,"blur":0,"size":1,"color":"rgba(13, 33, 48, 1)"},"lineColors":[],"textArray":[],"_id":"60d59891f86638684d1ece75","animationIn":"fadeInLeft","animationOut":"fadeOut","animationModeIn":"sequence","animationModeOut":"shuffle","backgroundColor":"rgba(56, 85, 57, 0)","backgroundColorHover":"rgba(155,155,155,0.5)","borderWidth":0,"boxId":"","borderRadius":0,"borderColor":"rgba(255,255,255,0.5)","borderColorHover":"rgba(255,255,255,0.5)","delayIn":0,"delayOut":0,"id":"id-1624863613465","index":1,"hasShadow":false,"fontColor":"rgba(255, 255, 255, 1)","fontColorHover":"rgba(33, 33, 33, 0.5)","fontFamily":{"value":"cormorantgaramond-light,cormorantgaramond,\\"cormorant garamond\\",serif","label":"Cormorant Garamond Light"},"fontSize":30,"letterCase":"uppercase","letterSpacing":41,"lineHeight":126,"mobileBorderWidth":0,"mobileBorderRadius":0,"mobileFontSize":16,"mobileLetterSpacing":14,"mobileLineHeight":120,"mobileShow":true,"isHover":false,"layer":1,"padding":0,"mobilePadding":0,"text":"CARE\\nCOSMETICS","type":"text","width":276.9965515136719,"height":73.33333587646484,"mobileWidth":198.97569274902344,"mobileHeight":38,"needMobileConvertOnlyPosition":true,"mobileHidden":false,"lang":{"en":{"text":"CARE\\nCOSMETICS","fontFamily":{"value":"cormorantgaramond-light,cormorantgaramond,\\"cormorant garamond\\",serif","label":"Cormorant Garamond Light"},"isRTL":false,"textArray":[]}}},{"mobilePosition":{"relativeX":10,"relativeY":10,"x":146,"y":41},"position":{"relativeX":50,"relativeY":50,"x":577,"y":136},"shadow":{"angle":135,"distance":4,"x":3,"y":3,"blur":5,"size":1,"color":"rgba(0,0,0,0.5)"},"lineColors":[],"textArray":[],"_id":"610950bad386e2342a7f6c04","animationIn":"fadeIn","animationOut":"fadeOut","backgroundColor":{"type":"color","colorValue":"rgba(171, 175, 247, 0)","gradientLayers":[{"angle":47,"firstColor":"rgba(234, 214, 238, 1)","secondColor":"rgba(160, 241, 234, 1)","transition":100}]},"borderColor":"rgba(240, 240, 240, 1)","borderRadius":{"leftTop":0,"rightTop":0,"leftBottom":0,"rightBottom":0},"mobileBorderRadius":{"leftBottom":0,"leftTop":0,"rightBottom":0,"rightTop":0},"borderWidth":0,"mobileBorderWidth":0,"delayIn":0,"delayOut":0,"hasShadow":false,"height":73.99305725097656,"mobileHeight":26.99652862548828,"mobileShow":true,"mobileWidth":111.99655151367188,"id":"id-1627992794512","boxId":"","index":2,"layer":1,"separateCorners":false,"type":"box","width":283.9930725097656,"separateCornersMobile":false},{"mobilePosition":{"relativeX":10,"relativeY":10,"x":11,"y":63},"onClick":{"label":"Do nothing","value":"doNothing"},"position":{"relativeX":30,"relativeY":30,"x":71,"y":220},"style":{"bold":false,"italic":false,"underline":false,"textAlign":"center"},"shadow":{"angle":135,"distance":0,"x":0,"y":0,"blur":19,"size":6,"color":"rgba(0, 0, 0, 0.55)"},"textShadow":{"angle":135,"distance":4,"x":3,"y":3,"blur":5,"size":1,"color":"rgba(0,0,0,0.5)"},"animation":{"value":"radial-out","label":"Radial out","class":"background"},"lineColors":[],"textArray":[],"_id":"610950bad386e2342a7f6c05","animationIn":"fadeIn","animationOut":"fadeOut","backgroundColor":"rgba(28, 28, 28, 0.15)","backgroundColorHover":"rgba(255, 255, 255, 0)","borderRadius":0,"mobileBorderRadius":0,"borderColor":"rgba(255,255,255,1)","borderColorHover":"rgba(155, 155, 155, 0)","borderWidth":2,"mobileBorderWidth":1,"delayIn":0,"delayOut":0,"id":"id-1627992886598","isHover":true,"hasShadow":true,"textHasShadow":false,"boxId":"","index":3,"layer":1,"fontColor":"rgba(255, 255, 255, 1)","fontColorHover":"rgba(252, 252, 252, 1)","fontFamily":{"value":"cormorantgaramond-light,cormorantgaramond,\\"cormorant garamond\\",serif","label":"Cormorant Garamond Light"},"fontShadow":false,"fontSize":24,"letterCase":"none","letterSpacing":5,"lineHeight":100,"mobileFontSize":12,"mobileShow":true,"mobileLetterSpacing":5,"mobileLineHeight":100,"linkTo":null,"padding":9,"mobilePadding":6,"text":"View catalog","type":"button","width":257.9861145019531,"height":49.30555725097656,"mobileWidth":95.00000762939453,"mobileHeight":27.32638931274414,"lang":{"en":{"text":"View catalog","fontFamily":{"value":"cormorantgaramond-light,cormorantgaramond,\\"cormorant garamond\\",serif","label":"Cormorant Garamond Light"},"isRTL":false}}}],"_id":"60d59891f86638684d1ece74","backgroundColor":"rgba(0, 0, 0, 0.34)","backgroundType":"gradient","backgroundGradient":[{"angle":95,"firstColor":"rgba(0, 0, 0, 0.41)","secondColor":"rgba(7, 77, 9, 0.1)","transition":100},{"angle":270,"firstColor":"rgba(160, 200, 254, 0.2)","secondColor":"rgba(251, 247, 173, 0)","transition":11}],"slideName":"COSMETICS 2","hasBackgroundShadow":false,"editedHeight":365,"editedWidth":970,"editedHeightMobile":105,"editedWidthMobile":280,"id":"1627990680425569","index":1,"isHide":false},{"backgroundShadow":{"angle":0,"distance":0,"x":0,"y":0,"blur":20,"size":10,"color":"rgba(0,0,0,0.3) inset"},"captions":[{"mobilePosition":{"relativeX":1,"relativeY":13.71527910232544,"x":65,"y":26},"position":{"x":706,"y":163,"relativeX":13,"relativeY":11},"style":{"bold":false,"italic":false,"underline":false,"textAlign":"center"},"shadow":{"angle":135,"distance":3,"x":2,"y":2,"blur":5,"size":1,"color":"rgba(0, 0, 0, 1)"},"lineColors":["rgba(255, 255, 255, 1)","rgba(255, 255, 255, 1)","rgba(255, 255, 255, 1)"],"textArray":["fresh","novel","original"],"_id":"60d59891f86638684d1ece75","animationIn":"countdownUp","animationOut":"fadeOutLeft","animationModeIn":"shuffle","animationModeOut":"sequence","backgroundColor":"rgba(41, 8, 88, 0)","backgroundColorHover":"rgba(155, 155, 155, 0)","borderWidth":0,"boxId":"id-1627992794512","borderRadius":0,"borderColor":"rgba(255,255,255,0.5)","borderColorHover":"rgba(255, 255, 255, 0)","delayIn":0,"delayOut":0,"id":"id-1613812434068","index":0,"hasShadow":false,"fontColor":"rgba(255, 255, 255, 1)","fontColorHover":"rgba(255, 255, 255, 1)","fontFamily":{"value":"helvetica-w01-light,helvetica-w02-light,sans-serif","label":"Helvetica Light"},"fontSize":35,"letterCase":"uppercase","letterSpacing":18,"lineHeight":149,"mobileBorderWidth":0,"mobileBorderRadius":0,"mobileFontSize":14,"mobileLetterSpacing":14,"mobileLineHeight":120,"mobileShow":true,"isHover":true,"layer":1,"padding":0,"mobilePadding":0,"text":["fresh","novel","original"],"type":"text","width":256.9965515136719,"height":51.111114501953125,"mobileWidth":105.00000762939453,"mobileHeight":15.555556297302246,"pauseBetweenLines":1000,"lang":{"en":{"text":["fresh","novel","original"],"fontFamily":{"value":"helvetica-w01-light,helvetica-w02-light,sans-serif","label":"Helvetica Light"},"isRTL":false,"textArray":["fresh","novel","original"]}}},{"mobilePosition":{"relativeX":10,"relativeY":10,"x":9,"y":14},"position":{"x":60,"y":87,"relativeX":13,"relativeY":96},"style":{"bold":false,"italic":false,"underline":false,"textAlign":"left"},"shadow":{"angle":135,"distance":3,"x":2,"y":2,"blur":0,"size":1,"color":"rgba(13, 33, 48, 1)"},"lineColors":[],"textArray":[],"_id":"60d59891f86638684d1ece75","animationIn":"fadeInLeft","animationOut":"fadeOut","animationModeIn":"sequence","animationModeOut":"shuffle","backgroundColor":"rgba(56, 85, 57, 0)","backgroundColorHover":"rgba(155,155,155,0.5)","borderWidth":0,"boxId":"","borderRadius":0,"borderColor":"rgba(255,255,255,0.5)","borderColorHover":"rgba(255,255,255,0.5)","delayIn":0,"delayOut":0,"id":"id-1624863613465","index":1,"hasShadow":false,"fontColor":"rgba(255, 255, 255, 1)","fontColorHover":"rgba(33, 33, 33, 0.5)","fontFamily":{"value":"cormorantgaramond-light,cormorantgaramond,\\"cormorant garamond\\",serif","label":"Cormorant Garamond Light"},"fontSize":30,"letterCase":"uppercase","letterSpacing":41,"lineHeight":129,"mobileBorderWidth":0,"mobileBorderRadius":0,"mobileFontSize":16,"mobileLetterSpacing":14,"mobileLineHeight":120,"mobileShow":true,"isHover":false,"layer":1,"padding":0,"mobilePadding":0,"text":"DECORATIVE COSMETICS","type":"text","width":340.0000305175781,"height":75.55555725097656,"mobileWidth":127.98611450195312,"mobileHeight":37.77777862548828,"needMobileConvertOnlyPosition":true,"mobileHidden":false,"lang":{"en":{"text":"DECORATIVE COSMETICS","fontFamily":{"value":"cormorantgaramond-light,cormorantgaramond,\\"cormorant garamond\\",serif","label":"Cormorant Garamond Light"},"isRTL":false,"textArray":[]}}},{"mobilePosition":{"relativeX":10,"relativeY":10,"x":156,"y":31.006942749023438},"position":{"relativeX":50,"relativeY":50,"x":600,"y":146},"shadow":{"angle":135,"distance":4,"x":3,"y":3,"blur":5,"size":1,"color":"rgba(0,0,0,0.5)"},"lineColors":[],"textArray":[],"_id":"610950bad386e2342a7f6c09","animationIn":"fadeIn","animationOut":"fadeOut","backgroundColor":{"type":"color","colorValue":"rgba(171, 175, 247, 0)","gradientLayers":[{"angle":47,"firstColor":"rgba(234, 214, 238, 1)","secondColor":"rgba(160, 241, 234, 1)","transition":100}]},"borderColor":"rgba(240, 240, 240, 1)","borderRadius":{"leftTop":0,"rightTop":0,"leftBottom":0,"rightBottom":0},"mobileBorderRadius":{"leftBottom":0,"leftTop":0,"rightBottom":0,"rightTop":0},"borderWidth":0,"mobileBorderWidth":0,"delayIn":0,"delayOut":0,"hasShadow":false,"height":73.99305725097656,"mobileHeight":42.986114501953125,"mobileShow":true,"mobileWidth":117.98611450195312,"id":"id-1627992794512","boxId":"","index":2,"layer":1,"separateCorners":false,"type":"box","width":283.9930725097656,"separateCornersMobile":false},{"mobilePosition":{"relativeX":10,"relativeY":10,"x":9,"y":66},"onClick":{"label":"Do nothing","value":"doNothing"},"position":{"relativeX":30,"relativeY":30,"x":63,"y":217},"style":{"bold":false,"italic":false,"underline":false,"textAlign":"center"},"shadow":{"angle":135,"distance":0,"x":0,"y":0,"blur":19,"size":6,"color":"rgba(0, 0, 0, 0.55)"},"textShadow":{"angle":135,"distance":4,"x":3,"y":3,"blur":5,"size":1,"color":"rgba(0,0,0,0.5)"},"animation":{"value":"radial-out","label":"Radial out","class":"background"},"lineColors":[],"textArray":[],"_id":"610950bad386e2342a7f6c0a","animationIn":"fadeIn","animationOut":"fadeOut","backgroundColor":"rgba(28, 28, 28, 0.15)","backgroundColorHover":"rgba(255, 255, 255, 0)","borderRadius":0,"mobileBorderRadius":0,"borderColor":"rgba(255,255,255,1)","borderColorHover":"rgba(155, 155, 155, 0)","borderWidth":2,"mobileBorderWidth":1,"delayIn":0,"delayOut":0,"id":"id-1627992886598","isHover":true,"hasShadow":true,"textHasShadow":false,"boxId":"","index":3,"layer":1,"fontColor":"rgba(255, 255, 255, 1)","fontColorHover":"rgba(252, 252, 252, 1)","fontFamily":{"value":"cormorantgaramond-light,cormorantgaramond,\\"cormorant garamond\\",serif","label":"Cormorant Garamond Light"},"fontShadow":false,"fontSize":24,"letterCase":"none","letterSpacing":5,"lineHeight":100,"mobileFontSize":12,"mobileShow":true,"mobileLetterSpacing":5,"mobileLineHeight":100,"linkTo":null,"padding":9,"mobilePadding":6,"text":"View catalog","type":"button","width":257.9861145019531,"height":49.30555725097656,"mobileWidth":100.98958587646484,"mobileHeight":27.32638931274414,"lang":{"en":{"text":"View catalog","fontFamily":{"value":"cormorantgaramond-light,cormorantgaramond,\\"cormorant garamond\\",serif","label":"Cormorant Garamond Light"},"isRTL":false}}}],"_id":"60d59891f86638684d1ece74","backgroundColor":"rgba(0, 0, 0, 0.34)","backgroundType":"gradient","backgroundGradient":[{"angle":95,"firstColor":"rgba(0, 0, 0, 0.59)","secondColor":"rgba(7, 77, 9, 0.1)","transition":100},{"angle":270,"firstColor":"rgba(160, 200, 254, 0.2)","secondColor":"rgba(251, 247, 173, 0)","transition":11}],"slideName":"COSMETICS 3","hasBackgroundShadow":false,"editedHeight":365,"editedWidth":970,"editedHeightMobile":105,"editedWidthMobile":280,"id":"1627994292909956","index":2,"isHide":false}]

const defaultSlidesArray = [
    {
        "backgroundShadow": {
            "angle": 0,
            "distance": 0,
            "x": 0,
            "y": 0,
            "blur": 20,
            "size": 10,
            "color": "rgba(0,0,0,0.3) inset"
        },
        "captions": [
            {
                "mobilePosition": {
                    "relativeX": 10,
                    "relativeY": 10,
                    "x": 72,
                    "y": 13
                },
                "position": {
                    "relativeX": 50,
                    "relativeY": 50,
                    "x": 303.50694274902344,
                    "y": 38
                },
                "shadow": {
                    "angle": 40,
                    "distance": 0,
                    "x": 0,
                    "y": 0,
                    "blur": 20,
                    "size": 8,
                    "color": "rgba(0,0,0,0.5)"
                },
                "lineColors": [
                ],
                "textArray": [
                ],
                "_id": "610950bad386e2342a7f6bfe",
                "animationIn": "fadeIn",
                "animationOut": "fadeOut",
                "backgroundColor": {
                    "type": "color",
                    "colorValue": "rgba(28, 28, 28, 0)",
                    "gradientLayers": [
                        {
                            "angle": 47,
                            "firstColor": "rgba(234, 214, 238, 1)",
                            "secondColor": "rgba(160, 241, 234, 1)",
                            "transition": 100
                        }
                    ]
                },
                "borderColor": "rgba(252, 252, 252, 1)",
                "borderRadius": {
                    "leftTop": 0,
                    "rightTop": 0,
                    "leftBottom": 0,
                    "rightBottom": 0
                },
                "mobileBorderRadius": {
                    "leftBottom": 0,
                    "leftTop": 0,
                    "rightBottom": 0,
                    "rightTop": 0
                },
                "borderWidth": 0,
                "mobileBorderWidth": 0,
                "delayIn": 0,
                "delayOut": 0,
                "hasShadow": true,
                "height": 277.98614501953125,
                "mobileHeight": 80,
                "mobileShow": true,
                "mobileWidth": 136.99654027035362,
                "id": "id-1627987644436",
                "boxId": "",
                "index": 0,
                "layer": 1,
                "separateCorners": false,
                "type": "box",
                "width": 362.9861145019531,
                "separateCornersMobile": false,
                "effectType": "backdrop",
                "glassEffect": 6
            },
            {
                "mobilePosition": {
                    "relativeX": 0,
                    "relativeY": 54,
                    "x": 65,
                    "y": 26
                },
                "position": {
                    "x": 350,
                    "y": 221,
                    "relativeX": 44.51390075683594,
                    "relativeY": 182
                },
                "style": {
                    "bold": false,
                    "italic": false,
                    "underline": false,
                    "textAlign": "center"
                },
                "shadow": {
                    "angle": 135,
                    "distance": 3,
                    "x": 2,
                    "y": 2,
                    "blur": 5,
                    "size": 1,
                    "color": "rgba(0, 0, 0, 1)"
                },
                "lineColors": [
                    "rgba(255, 255, 255, 1)",
                    "rgba(255, 255, 255, 1)",
                    "rgba(255, 255, 255, 1)"
                ],
                "textArray": [
                    "Emotions",
                    "FEELING",
                    "PHOTOS"
                ],
                "_id": "60d59891f86638684d1ece75",
                "animationIn": "none",
                "animationOut": "fadeOutLeft",
                "animationModeIn": "shuffle",
                "animationModeOut": "sequence",
                "backgroundColor": "rgba(41, 8, 88, 0)",
                "backgroundColorHover": "rgba(155,155,155,0.5)",
                "borderWidth": 0,
                "boxId": "id-1627987644436",
                "borderRadius": 0,
                "borderColor": "rgba(255,255,255,0.5)",
                "borderColorHover": "rgba(255,255,255,0.5)",
                "delayIn": 0,
                "delayOut": 0,
                "id": "id-1613812434068",
                "index": 1,
                "hasShadow": false,
                "fontColor": "rgba(255, 255, 255, 1)",
                "fontColorHover": "rgba(33, 33, 33, 0.5)",
                "fontFamily": {
                    "value": "helvetica-w01-light,helvetica-w02-light,sans-serif",
                    "label": "Helvetica Light"
                },
                "fontSize": 16,
                "letterCase": "uppercase",
                "letterSpacing": 84,
                "lineHeight": 149,
                "mobileBorderWidth": 0,
                "mobileBorderRadius": 0,
                "mobileFontSize": 14,
                "mobileLetterSpacing": 14,
                "mobileLineHeight": 120,
                "mobileShow": true,
                "isHover": false,
                "layer": 1,
                "padding": 0,
                "mobilePadding": 0,
                "text": "COSMETICS",
                "type": "text",
                "width": 273.9583740234375,
                "height": 22.22222328186035,
                "mobileWidth": 130.00003212376646,
                "mobileHeight": 16,
                "pauseBetweenLines": 1000,
                "lang": {
                    "en": {
                        "text": "COSMETICS",
                        "fontFamily": {
                            "value": "helvetica-w01-light,helvetica-w02-light,sans-serif",
                            "label": "Helvetica Light"
                        },
                        "isRTL": false,
                        "textArray": [
                            "Emotions",
                            "FEELING",
                            "PHOTOS"
                        ]
                    }
                }
            },
            {
                "mobilePosition": {
                    "relativeX": 9,
                    "relativeY": 6,
                    "x": 47,
                    "y": 60
                },
                "position": {
                    "x": 306,
                    "y": 155,
                    "relativeX": 44.51390075683594,
                    "relativeY": 78
                },
                "style": {
                    "bold": false,
                    "italic": false,
                    "underline": false,
                    "textAlign": "center"
                },
                "shadow": {
                    "angle": 135,
                    "distance": 3,
                    "x": 2,
                    "y": 2,
                    "blur": 0,
                    "size": 1,
                    "color": "rgba(13, 33, 48, 1)"
                },
                "lineColors": [
                ],
                "textArray": [
                ],
                "_id": "60d59891f86638684d1ece75",
                "animationIn": "fadeInLeft",
                "animationOut": "fadeOut",
                "animationModeIn": "sequence",
                "animationModeOut": "shuffle",
                "backgroundColor": "rgba(41, 8, 88, 0)",
                "backgroundColorHover": "rgba(155,155,155,0.5)",
                "borderWidth": 0,
                "boxId": "id-1627987644436",
                "borderRadius": 0,
                "borderColor": "rgba(255,255,255,0.5)",
                "borderColorHover": "rgba(255,255,255,0.5)",
                "delayIn": 0,
                "delayOut": 0,
                "id": "id-1624863613465",
                "index": 2,
                "hasShadow": true,
                "fontColor": "rgba(255, 255, 255, 1)",
                "fontColorHover": "rgba(33, 33, 33, 0.5)",
                "fontFamily": {
                    "value": "cormorantgaramond-light,cormorantgaramond,\"cormorant garamond\",serif", "label": "Cormorant Garamond Light"
                },
                "fontSize": 82,
                "letterCase": "uppercase",
                "letterSpacing": 25,
                "lineHeight": 113,
                "mobileBorderWidth": 0,
                "mobileBorderRadius": 0,
                "mobileFontSize": 43,
                "mobileLetterSpacing": 14,
                "mobileLineHeight": 120,
                "mobileShow": true,
                "isHover": false,
                "layer": 1,
                "padding": 0,
                "mobilePadding": 0,
                "text": "eco",
                "type": "text",
                "width": 273.9756774902344,
                "height": 91.11111450195312,
                "mobileWidth": 120.98956459446958,
                "mobileHeight": 50,
                "needMobileConvertOnlyPosition": true,
                "mobileHidden": false,
                "lang": {
                    "en": {
                        "text": "eco",
                        "fontFamily": {
                            "value": "cormorantgaramond-light,cormorantgaramond,\"cormorant garamond\",serif", "label": "Cormorant Garamond Light"
                        },
                        "isRTL": false,
                        "textArray": [
                        ]
                    }
                }
            }
        ],
        "_id": "60d59891f86638684d1ece74",
        "backgroundColor": "rgba(28, 28, 28, 0.24)",
        "backgroundType": "color",
        "backgroundGradient": [
            {
                "angle": 90,
                "firstColor": "rgba(13, 33, 48, 0.5)",
                "secondColor": "rgba(119, 114, 71, 0)",
                "transition": 32
            },
            {
                "angle": 270,
                "firstColor": "rgba(160, 200, 254, 0.2)",
                "secondColor": "rgba(251, 247, 173, 0)",
                "transition": 11
            }
        ],
        "slideName": "COSMETICS 1",
        "hasBackgroundShadow": false,
        "editedHeight": 365,
        "editedWidth": 970,
        "editedHeightMobile": 105,
        "editedWidthMobile": 280,
        "id": "585705103524561",
        "index": 0,
        "isHide": false
    },
    {
        "backgroundShadow": {
            "angle": 0,
            "distance": 0,
            "x": 0,
            "y": 0,
            "blur": 20,
            "size": 10,
            "color": "rgba(0,0,0,0.3) inset"
        },
        "captions": [
            {
                "mobilePosition": {
                    "relativeX": 0,
                    "relativeY": 6,
                    "x": 65,
                    "y": 26
                },
                "position": {
                    "x": 654,
                    "y": 175,
                    "relativeX": 18,
                    "relativeY": 14
                },
                "style": {
                    "bold": false,
                    "italic": false,
                    "underline": false,
                    "textAlign": "center"
                },
                "shadow": {
                    "angle": 135,
                    "distance": 3,
                    "x": 2,
                    "y": 2,
                    "blur": 5,
                    "size": 1,
                    "color": "rgba(0, 0, 0, 1)"
                },
                "lineColors": [
                    "rgba(255, 255, 255, 1)",
                    "rgba(255, 255, 255, 1)",
                    "rgba(255, 255, 255, 1)"
                ],
                "textArray": [
                    "fresh",
                    "novel",
                    "original"
                ],
                "_id": "60d59891f86638684d1ece75",
                "animationIn": "countdownUp",
                "animationOut": "fadeOutLeft",
                "animationModeIn": "shuffle",
                "animationModeOut": "sequence",
                "backgroundColor": "rgba(41, 8, 88, 0)",
                "backgroundColorHover": "rgba(155, 155, 155, 0)",
                "borderWidth": 0,
                "boxId": "id-1627992794512",
                "borderRadius": 0,
                "borderColor": "rgba(255,255,255,0.5)",
                "borderColorHover": "rgba(255, 255, 255, 0)",
                "delayIn": 0,
                "delayOut": 0,
                "id": "id-1613812434068",
                "index": 0,
                "hasShadow": false,
                "fontColor": "rgba(255, 255, 255, 1)",
                "fontColorHover": "rgba(255, 255, 255, 1)",
                "fontFamily": {
                    "value": "helvetica-w01-light,helvetica-w02-light,sans-serif",
                    "label": "Helvetica Light"
                },
                "fontSize": 35,
                "letterCase": "uppercase",
                "letterSpacing": 18,
                "lineHeight": 149,
                "mobileBorderWidth": 0,
                "mobileBorderRadius": 0,
                "mobileFontSize": 14,
                "mobileLetterSpacing": 14,
                "mobileLineHeight": 120,
                "mobileShow": true,
                "isHover": true,
                "layer": 1,
                "padding": 0,
                "mobilePadding": 0,
                "text": [
                    "fresh",
                    "novel",
                    "original"
                ],
                "type": "text",
                "width": 256.9965515136719,
                "height": 51.111114501953125,
                "mobileWidth": 130,
                "mobileHeight": 16,
                "pauseBetweenLines": 1000,
                "lang": {
                    "en": {
                        "text": [
                            "fresh",
                            "novel",
                            "original"
                        ],
                        "fontFamily": {
                            "value": "helvetica-w01-light,helvetica-w02-light,sans-serif",
                            "label": "Helvetica Light"
                        },
                        "isRTL": false,
                        "textArray": [
                            "fresh",
                            "novel",
                            "original"
                        ]
                    }
                }
            },
            {
                "mobilePosition": {
                    "relativeX": 10,
                    "relativeY": 10,
                    "x": 10,
                    "y": 13
                },
                "position": {
                    "x": 69,
                    "y": 91,
                    "relativeX": 13,
                    "relativeY": 96
                },
                "style": {
                    "bold": false,
                    "italic": false,
                    "underline": false,
                    "textAlign": "left"
                },
                "shadow": {
                    "angle": 135,
                    "distance": 3,
                    "x": 2,
                    "y": 2,
                    "blur": 0,
                    "size": 1,
                    "color": "rgba(13, 33, 48, 1)"
                },
                "lineColors": [
                ],
                "textArray": [
                ],
                "_id": "60d59891f86638684d1ece75",
                "animationIn": "fadeInLeft",
                "animationOut": "fadeOut",
                "animationModeIn": "sequence",
                "animationModeOut": "shuffle",
                "backgroundColor": "rgba(56, 85, 57, 0)",
                "backgroundColorHover": "rgba(155,155,155,0.5)",
                "borderWidth": 0,
                "boxId": "",
                "borderRadius": 0,
                "borderColor": "rgba(255,255,255,0.5)",
                "borderColorHover": "rgba(255,255,255,0.5)",
                "delayIn": 0,
                "delayOut": 0,
                "id": "id-1624863613465",
                "index": 1,
                "hasShadow": false,
                "fontColor": "rgba(255, 255, 255, 1)",
                "fontColorHover": "rgba(33, 33, 33, 0.5)",
                "fontFamily": {
                    "value": "cormorantgaramond-light,cormorantgaramond,\"cormorant garamond\",serif", "label": "Cormorant Garamond Light"
                },
                "fontSize": 30,
                "letterCase": "uppercase",
                "letterSpacing": 41,
                "lineHeight": 126,
                "mobileBorderWidth": 0,
                "mobileBorderRadius": 0,
                "mobileFontSize": 16,
                "mobileLetterSpacing": 14,
                "mobileLineHeight": 120,
                "mobileShow": true,
                "isHover": false,
                "layer": 1,
                "padding": 0,
                "mobilePadding": 0,
                "text": "CARE\nCOSMETICS",
                "type": "text",
                "width": 276.9965515136719,
                "height": 73.33333587646484,
                "mobileWidth": 198.97569274902344,
                "mobileHeight": 38,
                "needMobileConvertOnlyPosition": true,
                "mobileHidden": false,
                "lang": {
                    "en": {
                        "text": "CARE\\nCOSMETICS",
                        "fontFamily": {
                            "value": "cormorantgaramond-light,cormorantgaramond,\"cormorant garamond\",serif", "label": "Cormorant Garamond Light"
                        },
                        "isRTL": false,
                        "textArray": [
                        ]
                    }
                }
            },
            {
                "mobilePosition": {
                    "relativeX": 10,
                    "relativeY": 10,
                    "x": 146,
                    "y": 41
                },
                "position": {
                    "relativeX": 50,
                    "relativeY": 50,
                    "x": 577,
                    "y": 136
                },
                "shadow": {
                    "angle": 135,
                    "distance": 4,
                    "x": 3,
                    "y": 3,
                    "blur": 5,
                    "size": 1,
                    "color": "rgba(0,0,0,0.5)"
                },
                "lineColors": [
                ],
                "textArray": [
                ],
                "_id": "610950bad386e2342a7f6c04",
                "animationIn": "fadeIn",
                "animationOut": "fadeOut",
                "backgroundColor": {
                    "type": "color",
                    "colorValue": "rgba(171, 175, 247, 0)",
                    "gradientLayers": [
                        {
                            "angle": 47,
                            "firstColor": "rgba(234, 214, 238, 1)",
                            "secondColor": "rgba(160, 241, 234, 1)",
                            "transition": 100
                        }
                    ]
                },
                "borderColor": "rgba(240, 240, 240, 1)",
                "borderRadius": {
                    "leftTop": 0,
                    "rightTop": 0,
                    "leftBottom": 0,
                    "rightBottom": 0
                },
                "mobileBorderRadius": {
                    "leftBottom": 0,
                    "leftTop": 0,
                    "rightBottom": 0,
                    "rightTop": 0
                },
                "borderWidth": 0,
                "mobileBorderWidth": 0,
                "delayIn": 0,
                "delayOut": 0,
                "hasShadow": false,
                "height": 73.99305725097656,
                "mobileHeight": 26.99652862548828,
                "mobileShow": true,
                "mobileWidth": 111.99655151367188,
                "id": "id-1627992794512",
                "boxId": "",
                "index": 2,
                "layer": 1,
                "separateCorners": false,
                "type": "box",
                "width": 283.9930725097656,
                "separateCornersMobile": false
            },
            {
                "mobilePosition": {
                    "relativeX": 10,
                    "relativeY": 10,
                    "x": 11,
                    "y": 63
                },
                "onClick": {
                    "label": "Do nothing",
                    "value": "doNothing"
                },
                "position": {
                    "relativeX": 30,
                    "relativeY": 30,
                    "x": 71,
                    "y": 220
                },
                "style": {
                    "bold": false,
                    "italic": false,
                    "underline": false,
                    "textAlign": "center"
                },
                "shadow": {
                    "angle": 135,
                    "distance": 0,
                    "x": 0,
                    "y": 0,
                    "blur": 19,
                    "size": 6,
                    "color": "rgba(0, 0, 0, 0.55)"
                },
                "textShadow": {
                    "angle": 135,
                    "distance": 4,
                    "x": 3,
                    "y": 3,
                    "blur": 5,
                    "size": 1,
                    "color": "rgba(0,0,0,0.5)"
                },
                "animation": {
                    "value": "radial-out",
                    "label": "Radial out",
                    "class": "background"
                },
                "lineColors": [
                ],
                "textArray": [
                ],
                "_id": "610950bad386e2342a7f6c05",
                "animationIn": "fadeIn",
                "animationOut": "fadeOut",
                "backgroundColor": "rgba(28, 28, 28, 0.15)",
                "backgroundColorHover": "rgba(255, 255, 255, 0)",
                "borderRadius": 0,
                "mobileBorderRadius": 0,
                "borderColor": "rgba(255,255,255,1)",
                "borderColorHover": "rgba(155, 155, 155, 0)",
                "borderWidth": 2,
                "mobileBorderWidth": 1,
                "delayIn": 0,
                "delayOut": 0,
                "id": "id-1627992886598",
                "isHover": true,
                "hasShadow": true,
                "textHasShadow": false,
                "boxId": "",
                "index": 3,
                "layer": 1,
                "fontColor": "rgba(255, 255, 255, 1)",
                "fontColorHover": "rgba(252, 252, 252, 1)",
                "fontFamily": {
                    "value": "cormorantgaramond-light,cormorantgaramond,\"cormorant garamond\",serif", "label": "Cormorant Garamond Light"
                },
                "fontShadow": false,
                "fontSize": 24,
                "letterCase": "none",
                "letterSpacing": 5,
                "lineHeight": 100,
                "mobileFontSize": 12,
                "mobileShow": true,
                "mobileLetterSpacing": 5,
                "mobileLineHeight": 100,
                "linkTo": null,
                "padding": 9,
                "mobilePadding": 6,
                "text": "View catalog",
                "type": "button",
                "width": 257.9861145019531,
                "height": 49.30555725097656,
                "mobileWidth": 95.00000762939453,
                "mobileHeight": 27.32638931274414,
                "lang": {
                    "en": {
                        "text": "View catalog",
                        "fontFamily": {
                            "value": "cormorantgaramond-light,cormorantgaramond,\"cormorant garamond\",serif", "label": "Cormorant Garamond Light"
                        },
                        "isRTL": false
                    }
                }
            }
        ],
        "_id": "60d59891f86638684d1ece74",
        "backgroundColor": "rgba(0, 0, 0, 0.34)",
        "backgroundType": "gradient",
        "backgroundGradient": [
            {
                "angle": 95,
                "firstColor": "rgba(0, 0, 0, 0.41)",
                "secondColor": "rgba(7, 77, 9, 0.1)",
                "transition": 100
            },
            {
                "angle": 270,
                "firstColor": "rgba(160, 200, 254, 0.2)",
                "secondColor": "rgba(251, 247, 173, 0)",
                "transition": 11
            }
        ],
        "slideName": "COSMETICS 2",
        "hasBackgroundShadow": false,
        "editedHeight": 365,
        "editedWidth": 970,
        "editedHeightMobile": 105,
        "editedWidthMobile": 280,
        "id": "1627990680425569",
        "index": 1,
        "isHide": false
    },
    {
        "backgroundShadow": {
            "angle": 0,
            "distance": 0,
            "x": 0,
            "y": 0,
            "blur": 20,
            "size": 10,
            "color": "rgba(0,0,0,0.3) inset"
        },
        "captions": [
            {
                "mobilePosition": {
                    "relativeX": 1,
                    "relativeY": 13.71527910232544,
                    "x": 65,
                    "y": 26
                },
                "position": {
                    "x": 706,
                    "y": 163,
                    "relativeX": 13,
                    "relativeY": 11
                },
                "style": {
                    "bold": false,
                    "italic": false,
                    "underline": false,
                    "textAlign": "center"
                },
                "shadow": {
                    "angle": 135,
                    "distance": 3,
                    "x": 2,
                    "y": 2,
                    "blur": 5,
                    "size": 1,
                    "color": "rgba(0, 0, 0, 1)"
                },
                "lineColors": [
                    "rgba(255, 255, 255, 1)",
                    "rgba(255, 255, 255, 1)",
                    "rgba(255, 255, 255, 1)"
                ],
                "textArray": [
                    "fresh",
                    "novel",
                    "original"
                ],
                "_id": "60d59891f86638684d1ece75",
                "animationIn": "countdownUp",
                "animationOut": "fadeOutLeft",
                "animationModeIn": "shuffle",
                "animationModeOut": "sequence",
                "backgroundColor": "rgba(41, 8, 88, 0)",
                "backgroundColorHover": "rgba(155, 155, 155, 0)",
                "borderWidth": 0,
                "boxId": "id-1627992794512",
                "borderRadius": 0,
                "borderColor": "rgba(255,255,255,0.5)",
                "borderColorHover": "rgba(255, 255, 255, 0)",
                "delayIn": 0,
                "delayOut": 0,
                "id": "id-1613812434068",
                "index": 0,
                "hasShadow": false,
                "fontColor": "rgba(255, 255, 255, 1)",
                "fontColorHover": "rgba(255, 255, 255, 1)",
                "fontFamily": {
                    "value": "helvetica-w01-light,helvetica-w02-light,sans-serif",
                    "label": "Helvetica Light"
                },
                "fontSize": 35,
                "letterCase": "uppercase",
                "letterSpacing": 18,
                "lineHeight": 149,
                "mobileBorderWidth": 0,
                "mobileBorderRadius": 0,
                "mobileFontSize": 14,
                "mobileLetterSpacing": 14,
                "mobileLineHeight": 120,
                "mobileShow": true,
                "isHover": true,
                "layer": 1,
                "padding": 0,
                "mobilePadding": 0,
                "text": [
                    "fresh",
                    "novel",
                    "original"
                ],
                "type": "text",
                "width": 256.9965515136719,
                "height": 51.111114501953125,
                "mobileWidth": 105.00000762939453,
                "mobileHeight": 15.555556297302246,
                "pauseBetweenLines": 1000,
                "lang": {
                    "en": {
                        "text": [
                            "fresh",
                            "novel",
                            "original"
                        ],
                        "fontFamily": {
                            "value": "helvetica-w01-light,helvetica-w02-light,sans-serif",
                            "label": "Helvetica Light"
                        },
                        "isRTL": false,
                        "textArray": [
                            "fresh",
                            "novel",
                            "original"
                        ]
                    }
                }
            },
            {
                "mobilePosition": {
                    "relativeX": 10,
                    "relativeY": 10,
                    "x": 9,
                    "y": 14
                },
                "position": {
                    "x": 60,
                    "y": 87,
                    "relativeX": 13,
                    "relativeY": 96
                },
                "style": {
                    "bold": false,
                    "italic": false,
                    "underline": false,
                    "textAlign": "left"
                },
                "shadow": {
                    "angle": 135,
                    "distance": 3,
                    "x": 2,
                    "y": 2,
                    "blur": 0,
                    "size": 1,
                    "color": "rgba(13, 33, 48, 1)"
                },
                "lineColors": [
                ],
                "textArray": [
                ],
                "_id": "60d59891f86638684d1ece75",
                "animationIn": "fadeInLeft",
                "animationOut": "fadeOut",
                "animationModeIn": "sequence",
                "animationModeOut": "shuffle",
                "backgroundColor": "rgba(56, 85, 57, 0)",
                "backgroundColorHover": "rgba(155,155,155,0.5)",
                "borderWidth": 0,
                "boxId": "",
                "borderRadius": 0,
                "borderColor": "rgba(255,255,255,0.5)",
                "borderColorHover": "rgba(255,255,255,0.5)",
                "delayIn": 0,
                "delayOut": 0,
                "id": "id-1624863613465",
                "index": 1,
                "hasShadow": false,
                "fontColor": "rgba(255, 255, 255, 1)",
                "fontColorHover": "rgba(33, 33, 33, 0.5)",
                "fontFamily": {
                    "value": "cormorantgaramond-light,cormorantgaramond,\"cormorant garamond\",serif", "label": "Cormorant Garamond Light"
                },
                "fontSize": 30,
                "letterCase": "uppercase",
                "letterSpacing": 41,
                "lineHeight": 129,
                "mobileBorderWidth": 0,
                "mobileBorderRadius": 0,
                "mobileFontSize": 16,
                "mobileLetterSpacing": 14,
                "mobileLineHeight": 120,
                "mobileShow": true,
                "isHover": false,
                "layer": 1,
                "padding": 0,
                "mobilePadding": 0,
                "text": "DECORATIVE COSMETICS",
                "type": "text",
                "width": 340.0000305175781,
                "height": 75.55555725097656,
                "mobileWidth": 127.98611450195312,
                "mobileHeight": 37.77777862548828,
                "needMobileConvertOnlyPosition": true,
                "mobileHidden": false,
                "lang": {
                    "en": {
                        "text": "DECORATIVE COSMETICS",
                        "fontFamily": {
                            "value": "cormorantgaramond-light,cormorantgaramond,\"cormorant garamond\",serif", "label": "Cormorant Garamond Light"
                        },
                        "isRTL": false,
                        "textArray": [
                        ]
                    }
                }
            },
            {
                "mobilePosition": {
                    "relativeX": 10,
                    "relativeY": 10,
                    "x": 156,
                    "y": 31.006942749023438
                },
                "position": {
                    "relativeX": 50,
                    "relativeY": 50,
                    "x": 600,
                    "y": 146
                },
                "shadow": {
                    "angle": 135,
                    "distance": 4,
                    "x": 3,
                    "y": 3,
                    "blur": 5,
                    "size": 1,
                    "color": "rgba(0,0,0,0.5)"
                },
                "lineColors": [
                ],
                "textArray": [
                ],
                "_id": "610950bad386e2342a7f6c09",
                "animationIn": "fadeIn",
                "animationOut": "fadeOut",
                "backgroundColor": {
                    "type": "color",
                    "colorValue": "rgba(171, 175, 247, 0)",
                    "gradientLayers": [
                        {
                            "angle": 47,
                            "firstColor": "rgba(234, 214, 238, 1)",
                            "secondColor": "rgba(160, 241, 234, 1)",
                            "transition": 100
                        }
                    ]
                },
                "borderColor": "rgba(240, 240, 240, 1)",
                "borderRadius": {
                    "leftTop": 0,
                    "rightTop": 0,
                    "leftBottom": 0,
                    "rightBottom": 0
                },
                "mobileBorderRadius": {
                    "leftBottom": 0,
                    "leftTop": 0,
                    "rightBottom": 0,
                    "rightTop": 0
                },
                "borderWidth": 0,
                "mobileBorderWidth": 0,
                "delayIn": 0,
                "delayOut": 0,
                "hasShadow": false,
                "height": 73.99305725097656,
                "mobileHeight": 42.986114501953125,
                "mobileShow": true,
                "mobileWidth": 117.98611450195312,
                "id": "id-1627992794512",
                "boxId": "",
                "index": 2,
                "layer": 1,
                "separateCorners": false,
                "type": "box",
                "width": 283.9930725097656,
                "separateCornersMobile": false
            },
            {
                "mobilePosition": {
                    "relativeX": 10,
                    "relativeY": 10,
                    "x": 9,
                    "y": 66
                },
                "onClick": {
                    "label": "Do nothing",
                    "value": "doNothing"
                },
                "position": {
                    "relativeX": 30,
                    "relativeY": 30,
                    "x": 63,
                    "y": 217
                },
                "style": {
                    "bold": false,
                    "italic": false,
                    "underline": false,
                    "textAlign": "center"
                },
                "shadow": {
                    "angle": 135,
                    "distance": 0,
                    "x": 0,
                    "y": 0,
                    "blur": 19,
                    "size": 6,
                    "color": "rgba(0, 0, 0, 0.55)"
                },
                "textShadow": {
                    "angle": 135,
                    "distance": 4,
                    "x": 3,
                    "y": 3,
                    "blur": 5,
                    "size": 1,
                    "color": "rgba(0,0,0,0.5)"
                },
                "animation": {
                    "value": "radial-out",
                    "label": "Radial out",
                    "class": "background"
                },
                "lineColors": [
                ],
                "textArray": [
                ],
                "_id": "610950bad386e2342a7f6c0a",
                "animationIn": "fadeIn",
                "animationOut": "fadeOut",
                "backgroundColor": "rgba(28, 28, 28, 0.15)",
                "backgroundColorHover": "rgba(255, 255, 255, 0)",
                "borderRadius": 0,
                "mobileBorderRadius": 0,
                "borderColor": "rgba(255,255,255,1)",
                "borderColorHover": "rgba(155, 155, 155, 0)",
                "borderWidth": 2,
                "mobileBorderWidth": 1,
                "delayIn": 0,
                "delayOut": 0,
                "id": "id-1627992886598",
                "isHover": true,
                "hasShadow": true,
                "textHasShadow": false,
                "boxId": "",
                "index": 3,
                "layer": 1,
                "fontColor": "rgba(255, 255, 255, 1)",
                "fontColorHover": "rgba(252, 252, 252, 1)",
                "fontFamily": {
                    "value": "cormorantgaramond-light,cormorantgaramond,\"cormorant garamond\",serif", "label": "Cormorant Garamond Light"
                },
                "fontShadow": false,
                "fontSize": 24,
                "letterCase": "none",
                "letterSpacing": 5,
                "lineHeight": 100,
                "mobileFontSize": 12,
                "mobileShow": true,
                "mobileLetterSpacing": 5,
                "mobileLineHeight": 100,
                "linkTo": null,
                "padding": 9,
                "mobilePadding": 6,
                "text": "View catalog",
                "type": "button",
                "width": 257.9861145019531,
                "height": 49.30555725097656,
                "mobileWidth": 100.98958587646484,
                "mobileHeight": 27.32638931274414,
                "lang": {
                    "en": {
                        "text": "View catalog",
                        "fontFamily": {
                            "value": "cormorantgaramond-light,cormorantgaramond,\"cormorant garamond\",serif", "label": "Cormorant Garamond Light"
                        },
                        "isRTL": false
                    }
                }
            }
        ],
        "_id": "60d59891f86638684d1ece74",
        "backgroundColor": "rgba(0, 0, 0, 0.34)",
        "backgroundType": "gradient",
        "backgroundGradient": [
            {
                "angle": 95,
                "firstColor": "rgba(0, 0, 0, 0.59)",
                "secondColor": "rgba(7, 77, 9, 0.1)",
                "transition": 100
            },
            {
                "angle": 270,
                "firstColor": "rgba(160, 200, 254, 0.2)",
                "secondColor": "rgba(251, 247, 173, 0)",
                "transition": 11
            }
        ],
        "slideName": "COSMETICS 3",
        "hasBackgroundShadow": false,
        "editedHeight": 365,
        "editedWidth": 970,
        "editedHeightMobile": 105,
        "editedWidthMobile": 280,
        "id": "1627994292909956",
        "index": 2,
        "isHide": false
    }
]

const defaultSettings = {
    parallaxImage: [
        {
            height:3819,
            mobileOffsetX:-50,
            mobileOffsetY:-201,
            mobileScale:1.3571428571428572,
            offsetX:-50,
            offsetY:-531,
            relativeUri:"fdaafd_317c39925434405eaf86a1d9c2e5a1b1~mv2.jpg",
            scale:1.1030927835051547,
            width:2864,
            _id:"610950bad386e2342a7f6bfc"
        }
    ]
}

let slideOne = JSON.parse(JSON.stringify(defaultSlideState));
slideOne.slideName = 'Slide 1';

slideOne.captions.push(JSON.parse(JSON.stringify(defaultCaptionState)));
slideOne.captions.push(JSON.parse(JSON.stringify(defaultCaptionState)));

slideOne.captions[0].position = { x: 223, y: 70 }
slideOne.captions[0].id = 1 + Math.round(Math.random() * 100000);
// slideOne.captions[0].id = setTimeout(() => Date.now(), 0)
slideOne.captions[0].index = 0
slideOne.captions[0].text = 'Your Message Goes Here'
slideOne.captions[0].width = 458.7;
slideOne.captions[0].height = 45;

slideOne.captions[1].position = { x: 255, y: 150 };
slideOne.captions[1].text = "Add catchy text to grab your audience's attention";
slideOne.captions[1].width = 431.8;
slideOne.captions[1].height = 23;

slideOne.captions[1].fontFamily = 'Sans-serif';
slideOne.captions[1].fontSize = 20;
slideOne.captions[1].id = 1 + Math.round(Math.random() * 100000);
// slideOne.captions[1].id = setTimeout(() => Date.now(), 1)
slideOne.captions[1].index = 1
slideOne.captions[1].animationIn = 'fadeIn';
slideOne.captions[1].animationOut = 'fadeOut';
slideOne.captions[1].delayIn = 0;
// slideOne.captions[1].delayIn = 6000;
slideOne.captions[1].delayOut = 0;

let slideTwo = JSON.parse(JSON.stringify(defaultSlideState));
slideTwo.slideName = 'Slide 2';
slideTwo.captions = [];
slideTwo.captions.push(JSON.parse(JSON.stringify(defaultCaptionState)));
slideTwo.captions.push(JSON.parse(JSON.stringify(defaultCaptionState)));

slideTwo.captions[0].position = { x: 168, y: 70 };
slideTwo.captions[0].text = 'Your Message Goes Here';
slideTwo.captions[0].width = 630.8;
slideTwo.captions[0].height = 64;

slideTwo.captions[0].id = 1 + Math.round(Math.random() * 100000);
// slideTwo.captions[0].id = setTimeout(() => Date.now(), 2);
slideTwo.captions[0].index = 0;
slideTwo.captions[0].fontSize = 55;
slideTwo.captions[0].animationIn = 'fadeInDown';
slideTwo.captions[0].animationModeIn = 'sync';
slideTwo.captions[0].animationOut = 'fadeOut';

slideTwo.captions[1].position = { x: 168, y: 204 };
slideTwo.captions[1].text = "Add catchy text to grab your audience's attention";
slideTwo.captions[1].fontFamily = 'helvetica-w01-light, helvetica-w02-light, sans-serif'
slideTwo.captions[1].fontSize = 20;
slideTwo.captions[1].id = 1 + Math.round(Math.random() * 100000);
// slideTwo.captions[1].id = setTimeout(() => Date.now(), 3);
slideTwo.captions[1].index = 1;
slideTwo.captions[1].animationIn = 'fadeInUp';
slideTwo.captions[1].animationModeIn = 'sync';
slideTwo.captions[1].animationModeOut = 'sync';
slideTwo.captions[1].delayIn = 0;
// slideTwo.captions[1].delayIn = 6000;
slideTwo.captions[1].delayOut = 0;
slideTwo.captions[1].width = 431.8;
slideTwo.captions[1].height = 23;

export const defaultSettingsState = {
    activeDotsColor: 'rgba(0, 0, 0, 0.3)',
    animationMode: 'slide',
    // animationsOnHover: false,
    arrows: 0,
    captionPlayMode: 'oneByOne',
    deviceType: 'desktop',
    dotsColor: 'rgba(0, 0, 0, 0.1)',
    dotsSize: 15,
    backgroundType: 'image',
    dotsType: 'none',
    dotsSpacing: 10,
    hasArrows: true,
    // // hasBackgroundTransparency: false,
    hasDisableRightClick: false, // premium
    hasDots: false,
    hasNavigationOnHover: false, // premium
    hasParallax: true, // premium
    hasWidgetBgColor: false,
    hoverDotsColor: 'rgba(0, 0, 0, 0.3)',
    // mobileDotsSize: 8,
    // parallaxImage: [{
    //     // height: '100',
    //     mobileScale: 1.66,
    //     mobileOffsetX: -43,
    //     mobileOffsetY: -59,
    //     offsetX: -140,
    //     offsetY: -165,
    //     scale: 1.49,
    //     relativeUri: "nsplsh_6e644d4d4d64564d506873~mv2.jpg",
    //     width: 5464,
    //     height: 3070,
    // }], // premium
    parallaxImage: defaultSettings.parallaxImage,
    parallaxType: 'classic',
    templatePreview: {
        needShow: false,
        templateIndex: 0,
    },
    pauseDuration: 1500,
    sensivity: 20,
    slideAnimationSpeed: 800,
    sliderMode: 'horizontal', // premium?
    slides: defaultSlidesArray,
    toasts: [
        { id: 1, message: 'Right click to edit text' },
        { id: 2, message: 'Arrows + "Shift" for 10px movement' },
        { id: 3, message: "If you hide elements on the mobile version, it will not be hidden in the desktop version and vice-versa" },
    ],
    version: 3,
    widgetDimensions: {
        height: 365,
        width: 970,
        mobileHeight: 105,
        mobileWidth: 280,
        editedWidth: 970,
        editedHeight: 365,
        editedWidthMobile: 280,
        editedHeightMobile: 105,
    },
    widgetBgColor: 'rgba(255,255,255,0)',
    customTemplates: [],
    // publishDate: Date.now(),

    // widgetMobileDimensions: {
    //     
    // }
    lastDateUpdate: 1,

}


export const defaultViewsState = {
    settingsAnimationViewDisplay: 'none',
    settingsNavigationViewDisplay: 'none',
    settingsParalaxViewDisplay: 'none',
    settingsWidgetViewDisplay: 'none',
    settingsCustomFontsViewDisplay: 'none',
    settingsDrilldownsDisplay: 'block',
    deleteSlideDisplay: 'none',
    slidesIndexToDelete: null,

    editSlideDrilldownsDisplay: 'block',
    editSlideCaptionSettingsDisplay: 'none',
    editSlideSettingsDisplay: 'none',
    editSlideAnimationSettingsDisplay: 'none',
    elementSettingsDrilldownsDisplay: 'none',
    linkSettingsDisplay: 'none',
    layersDisplay: 'none',

    // editSlideDrilldownsTransform: 'scaleX(1)',
    // editSlideCaptionSettingsTransform: 'scaleX(0)',
    // editSlideSettingsTransform: 'scaleX(0)',
    // editSlideAnimationSettingsTransform: 'scaleX(0)',
}

export const defaultEditSlideMenuState = {
    captionSelectedArray: [],
    editingCaptionIndex: null,
    // editingCaptionIndex: 0,
    copyCaptions: [],
    editingText: false,
    viewType: 'desktop',
    undoActive: false,
    redoActive: false,
    // addActive: true,
    shiftIsPress: false,
    ctrlIsPress: false,
    gridOn: false,
    pipettOn: false,
    previewSlide: false,
    rulers: false,
    rulersArray: [],
    rulersArrayMobile: [],
    fontPickerIsOpen: false,
    shadowPickerIsOpen: false,
    fontPickerPosition: { x: 0, y: 100 },
    shadowPickerPosition: { x: 0, y: 100 },
    boxFigureIsEdit: false,
    mobileViewScale: 100,
    workspaceRandom: 12345,
    toggleEditingTextPanelTime: 0,
    isImageCrop: false,
    svgModalOn: false,
}

export const defaultWidgetMenuState = {
    currentSlide: 0,
}
